import { Outlet } from "react-router-dom";

import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "./Admin.css";


function Admin() {
  const [list, setList] = useState([]);
  const [name, setName] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [editId, setEditId] = useState(null);

  const token = localStorage.getItem("token");

  // redirect if not logged in
  if (!token) {
    window.location.href = "/login";
  }

  // fetch all records
  const fetchData = async () => {
    const res = await fetch("/api/all-ids", {
      headers: { Authorization: token },
    });
    const data = await res.json();
    setList(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // add or update
  const handleSubmit = async () => {
    const url = editId ? "/api/update-id" : "/api/add-id";

    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        id: editId,
        user_name: name,
        id_number: idNumber,
      }),
    });

    setName("");
    setIdNumber("");
    setEditId(null);
    fetchData();
  };

  // delete
  const deleteRecord = async (id) => {
    if (!window.confirm("Delete this record?")) return;

    await fetch("/api/delete-id", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({ id }),
    });

    fetchData();
  };

  // edit
  const editRecord = (item) => {
    setName(item.user_name);
    setIdNumber(item.id_number);
    setEditId(item.id);
  };

  return (
    <>
      <Header />
  
      <div className="admin-layout">
  
        {/* Sidebar */}
        <div className="sidebar">
          <h3>Admin</h3>
  
          <ul>
            <li><a href="/admin">Dashboard</a></li>
            <li><a href="/admin/users">Users</a></li>
            <li><a href="/admin/reports">Reports</a></li>
            <li><a href="/admin/settings">Settings</a></li>
          </ul>
        </div>
  
        {/* Main Content */}
        <div className="admin-wrapper">
          <Outlet />
        </div>
  
      </div>
  
      <Footer />
    </>
  );
}

export default Admin;